import Iphone from '../src/Iphone';
export default Iphone;
